<div class="card mb-3">
  <div class="card-header">
    {{ 'authenticated.time_tracking.employees.edit.vacation_days.card_header' | translate }}
  </div>
  <div class="card-body">
    <app-table
      id="dashboard.time-tracking.employees.yearly-vacation-days.index"
      [showBorder]="false"
      [showTopRow]="false"
      [isSubtable]="true"
      [replaceParametersInUrl]="{'{employee}': employee.id}"
      [showEditLink]="false"
      [putTableParametersInUrl]="false"
      [reloadEmitter]="reloadTable$"
      [functionList]="tableFunctionList"
    ></app-table>

    @if (!isAdding) {
      <div class="d-flex justify-content-end">
        <button class="btn btn-primary" (click)="startAdding()">
          {{ 'authenticated.time_tracking.employees.edit.vacation_days.edit_btn' | translate }}
        </button>
      </div>
    } @else {
      <form [formGroup]="form" (submit)="save()" class="row mt-3">

        <div class="col-12 col-lg-6 py-1">
          <app-date-time
            [formControl]="form.controls.valid_from"
            [label]="'authenticated.time_tracking.employees.edit.vacation_days.form.valid_from.label' | translate"
            [errorMessages]="{required: ('authenticated.time_tracking.employees.edit.vacation_days.form.valid_from.validation_messages.required' | translate)}"
          ></app-date-time>
        </div>

        <div class="col-12 col-lg-6 py-1">
          <app-form-group
            [formControl]="form.controls.days"
            [label]="'authenticated.time_tracking.employees.edit.vacation_days.form.days.label' | translate"
            [errorMessages]="{required: ('authenticated.time_tracking.employees.edit.vacation_days.form.days.validation_messages.required' | translate)}"
          ></app-form-group>
        </div>

        <div class="col-12 d-flex justify-content-end gap-3">
          <button class="btn btn-outline-danger" type="button" (click)="cancel()">
            {{ 'authenticated.time_tracking.employees.edit.vacation_days.cancel_btn' | translate }}
          </button>

          <button class="btn btn-primary" type="button" (click)="save()">
            {{ 'authenticated.time_tracking.employees.edit.vacation_days.submit_btn' | translate }}
          </button>
        </div>

      </form>
    }
  </div>
</div>
